export default {
  // 当绑定元素插入父节点时调用
  inserted(el) {
    const handleInput = (e) => {
      // 防止中文输入法选词过程中强制转换
      if (e.isComposing) return;
      
      const target = e.target;
      const upperValue = target.value.toUpperCase();
      
      if (target.value !== upperValue) {
        target.value = upperValue;
        // 手动触发 input 事件以更新 v-model
        target.dispatchEvent(new Event('input'));
      }
    };

    const startComposition = () => {
      el.isComposing = true;
    };

    const endComposition = (e) => {
      el.isComposing = false;
      handleInput(e);
    };

    el.addEventListener('input', handleInput);
    el.addEventListener('compositionstart', startComposition);
    el.addEventListener('compositionend', endComposition);

    // 保存引用以便解绑
    el._upperCaseHandlers = {
      input: handleInput,
      start: startComposition,
      end: endComposition
    };
  },
  // 当指令与元素解绑时调用
  unbind(el) {
    if (el._upperCaseHandlers) {
      el.removeEventListener('input', el._upperCaseHandlers.input);
      el.removeEventListener('compositionstart', el._upperCaseHandlers.start);
      el.removeEventListener('compositionend', el._upperCaseHandlers.end);
    }
  }
};
